module.exports = {
  src: __webpack_public_path__ + "static/media/families_00010.74b66555.jpg",
  width: 4200,
  height: 3300,
  bytes: 446500,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/families_00010.74b66555.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/families/families_00010.jpg
// module id = 379
// module chunks = 0